var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#0A64C8",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5190_4090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1667 68.3333C47.1667 69.255 46.42 70 45.5 70H38.8333C34.2383 70 30.5 66.2617 30.5 61.6667V38.3333C30.5 33.7383 34.2383 30 38.8333 30H52.1667C56.7617 30 60.5 33.7383 60.5 38.3333V41.6667C60.5 42.5867 59.7533 43.3333 58.8333 43.3333C57.9133 43.3333 57.1667 42.5867 57.1667 41.6667V38.3333C57.1667 35.5767 54.9233 33.3333 52.1667 33.3333H38.8333C36.0767 33.3333 33.8333 35.5767 33.8333 38.3333V61.6667C33.8333 64.4233 36.0767 66.6667 38.8333 66.6667H45.5C46.42 66.6667 47.1667 67.4117 47.1667 68.3333ZM58.8333 46.6667C52.4 46.6667 47.1667 51.9017 47.1667 58.3333C47.1667 64.765 52.4 70 58.8333 70C65.2667 70 70.5 64.765 70.5 58.3333C70.5 51.9017 65.2667 46.6667 58.8333 46.6667ZM58.8333 66.6667C54.2383 66.6667 50.5 62.9283 50.5 58.3333C50.5 53.7383 54.2383 50 58.8333 50C63.4283 50 67.1667 53.7383 67.1667 58.3333C67.1667 62.9283 63.4283 66.6667 58.8333 66.6667ZM64.2017 56.3133C64.84 56.9767 64.8183 58.0317 64.1533 58.67L60.4667 62.21C59.7133 62.9533 58.7133 63.3283 57.7117 63.3283C56.71 63.3283 55.705 62.9533 54.9383 62.205L53.0517 60.3583C52.3933 59.7133 52.3833 58.6583 53.0267 58.0017C53.6717 57.3433 54.7267 57.3333 55.3833 57.975L57.27 59.8217C57.51 60.0567 57.9017 60.0583 58.14 59.8217L61.845 56.265C62.5083 55.63 63.5633 55.6483 64.2017 56.3133Z",
    fill: "#0A64C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1667 38.6667C49.1667 37.745 48.42 37 47.5 37H44.1667C43.2467 37 42.5 37.745 42.5 38.6667C42.5 39.5883 43.2467 40.3333 44.1667 40.3333H47.5C48.42 40.3333 49.1667 39.5883 49.1667 38.6667Z",
    fill: "#0A64C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5190_4090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(30.5 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.a8e9fd9c0633e22f041bc52a7b8b25c3.svg";
export { ForwardRef as ReactComponent };